import {toPersianDigits} from './numericInput';

const TYPE_META = {
  copper_buy:{weightDecimals:4,title:'خرید مس',asset:'مس',weightLabel:'وزن مس',amountLabel:'مبلغ سفارش',priceLabel:'نرخ هر گرم مس'},
  copper_sell:{weightDecimals:4,title:'فروش مس به مکعب',asset:'مس',weightLabel:'وزن مس',amountLabel:'وجه فروش',priceLabel:'نرخ بازخرید هر گرم مس'},
  silver_buy: {
    title: 'خرید ساچمه نقره',
    asset: 'نقره',
    weightLabel: 'مقدار نقره',
    amountLabel: 'مبلغ سفارش',
    priceLabel: 'نرخ هر گرم نقره',
  },
  buy: {
    title: 'خرید نقره',
    asset: 'نقره',
    weightLabel: 'مقدار نقره',
    amountLabel: 'مبلغ سفارش',
    priceLabel: 'نرخ هر گرم نقره',
  },
  bar_buy: {
    title: 'خرید شمش نقره',
    asset: 'شمش نقره',
    weightLabel: 'مقدار شمش',
    amountLabel: 'مبلغ سفارش',
    priceLabel: 'نرخ هر گرم شمش',
  },
  gold_buy: {
    title: 'خرید طلا',
    asset: 'طلا',
    weightLabel: 'مقدار طلا',
    amountLabel: 'مبلغ سفارش',
    priceLabel: 'نرخ هر گرم طلا',
  },
  silver_sell: {
    title: 'فروش نقره به مکعب',
    asset: 'نقره',
    weightLabel: 'مقدار نقره',
    amountLabel: 'مبلغ معامله',
    priceLabel: 'نرخ هر گرم نقره',
  },
  sell: {
    title: 'فروش نقره به مکعب',
    asset: 'نقره',
    weightLabel: 'مقدار نقره',
    amountLabel: 'مبلغ معامله',
    priceLabel: 'نرخ هر گرم نقره',
  },
  bar_sell: {
    title: 'فروش شمش نقره به مکعب',
    asset: 'شمش نقره',
    weightLabel: 'مقدار شمش',
    amountLabel: 'مبلغ معامله',
    priceLabel: 'نرخ هر گرم شمش',
  },
  gold_sell: {
    title: 'فروش طلا به مکعب',
    asset: 'طلا',
    weightLabel: 'مقدار طلا',
    amountLabel: 'مبلغ معامله',
    priceLabel: 'نرخ هر گرم طلا',
  },
  silver_transfer: {
    title: 'انتقال نقره',
    asset: 'نقره',
    weightLabel: 'مقدار انتقال',
    amountLabel: 'مبلغ',
    priceLabel: 'نرخ هر گرم',
  },
  physical_delivery: {
    title: 'درخواست تحویل فیزیکی',
    asset: 'نقره',
    weightLabel: 'مقدار تحویل',
    amountLabel: 'مبلغ',
    priceLabel: 'نرخ هر گرم',
  },
  wallet_charge: {
    title: 'شارژ کیف پول',
    asset: 'کیف پول ریالی',
    amountLabel: 'مبلغ شارژ',
  },
  wallet_withdrawal: {
    title: 'برداشت از کیف پول',
    asset: 'کیف پول ریالی',
    amountLabel: 'مبلغ برداشت',
  },
  balance_adjustment: {
    title: 'اصلاح موجودی',
    asset: 'موجودی حساب',
    weightLabel: 'مقدار فلز',
    amountLabel: 'مبلغ اصلاح',
    priceLabel: 'نرخ هر گرم',
  },
};

const STATUS_META = {
  awaiting_settlement: {label:"تأیید اولیه؛ منتظر وصول",tone:"pending",stage:"request",summary:"فیش تأیید اولیه شده و برای تأمین ثبت شده است. موجودی این درخواست پس از وصول وجه قابل استفاده می‌شود."},
  pending: {
    label: 'در انتظار بررسی',
    tone: 'pending',
    stage: 'request',
    summary: 'درخواست ثبت شده؛ نتیجهٔ نهایی هنوز مشخص نیست.',
  },
  approved: {
    label: 'تأیید شده',
    tone: 'approved',
    stage: 'verified',
    summary: 'این تراکنش تأیید شده.',
  },
  paid: {
    label: 'پرداخت شده',
    tone: 'approved',
    stage: 'paid',
    summary: 'پرداخت این درخواست ثبت شده.',
  },
  completed: {
    label: 'تکمیل شده',
    tone: 'completed',
    stage: 'completed',
    summary: 'این تراکنش تکمیل شده.',
  },
  rejected: {
    label: 'رد شده',
    tone: 'rejected',
    stage: 'rejected',
    summary: 'این درخواست تأیید نشده.',
  },
  failed: {
    label: 'ناموفق',
    tone: 'rejected',
    stage: 'failed',
    summary: 'این تراکنش با وضعیت ناموفق ثبت شده.',
  },
};

function numberValue(value) {
  if (value === null || value === undefined || value === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

function hasNonZeroNumber(value) {
  const parsed = numberValue(value);
  return parsed !== null && parsed !== 0;
}

export function formatRial(value) {
  const parsed = numberValue(value);
  if (parsed === null) return 'ثبت نشده';
  return `${toPersianDigits(Math.round(parsed).toLocaleString('en-US'))} ریال`;
}

export function formatGram(value,decimals=3) {
  const parsed = numberValue(value);
  if (parsed === null) return 'ثبت نشده';
  if (parsed > 0 && parsed < 0.001 && decimals===3) return 'کمتر از ۰٫۰۰۱ گرم';
  const formatted = new Intl.NumberFormat('en-US', {maximumFractionDigits: decimals}).format(parsed);
  return `${toPersianDigits(formatted)} گرم`;
}

function toJalali(gy, gm, gd) {
  const monthDays = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
  let jy = gy <= 1600 ? 0 : 979;
  gy = gy <= 1600 ? gy - 621 : gy - 1600;
  const gy2 = gm > 2 ? gy + 1 : gy;
  let days = 365 * gy + Math.floor((gy2 + 3) / 4) - Math.floor((gy2 + 99) / 100)
    + Math.floor((gy2 + 399) / 400) - 80 + gd + monthDays[gm - 1];
  jy += 33 * Math.floor(days / 12053);
  days %= 12053;
  jy += 4 * Math.floor(days / 1461);
  days %= 1461;
  if (days > 365) {
    jy += Math.floor((days - 1) / 365);
    days = (days - 1) % 365;
  }
  const jm = days < 186 ? 1 + Math.floor(days / 31) : 7 + Math.floor((days - 186) / 30);
  const jd = 1 + (days < 186 ? days % 31 : (days - 186) % 30);
  return [jy, jm, jd];
}

export function formatTransactionDate(value) {
  if (!value) return 'ثبت نشده';
  const raw = String(value);
  const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2}))?/);
  if (!match) return raw;
  const [jy, jm, jd] = toJalali(Number(match[1]), Number(match[2]), Number(match[3]));
  const date = `${jy}/${String(jm).padStart(2, '0')}/${String(jd).padStart(2, '0')}`;
  const time = match[4] ? `، ${match[4]}:${match[5]}` : '';
  return toPersianDigits(`${date}${time}`);
}

function statusFor(status) {
  if (STATUS_META[status]) return {...STATUS_META[status], raw: status};
  if (status) {
    return {
      label: 'وضعیت ثبت‌شده',
      tone: 'unknown',
      stage: 'unknown',
      summary: `وضعیت ثبت‌شده در سامانه: ${status}`,
      raw: status,
    };
  }
  return {
    label: 'وضعیت ثبت نشده',
    tone: 'unknown',
    stage: 'unknown',
    summary: 'وضعیت این تراکنش توی دادهٔ فعلی ثبت نشده.',
    raw: null,
  };
}

function receiptFor(receiptFile) {
  if (!receiptFile) return null;
  const filename = String(receiptFile).trim();
  if (!filename) return null;
  return {
    label: 'دیدن فیش ثبت‌شده',
    href: `/api/v1/uploads/${encodeURIComponent(filename)}`,
  };
}

export function buildTransactionDetail(transaction = {}) {
  const type = transaction.type || '';
  const meta = TYPE_META[type] || {
    title: 'جزئیات تراکنش',
    asset: 'ثبت نشده',
    weightLabel: 'مقدار فلز',
    amountLabel: 'مبلغ',
    priceLabel: 'نرخ هر گرم',
  };
  const rows = [];

  if (meta.asset) rows.push({key: 'asset', label: 'دارایی', value: meta.asset});
  if (meta.weightLabel && hasNonZeroNumber(transaction.silver_gram)) {
    rows.push({key: 'weight', label: meta.weightLabel, value: formatGram(transaction.silver_gram,meta.weightDecimals||3), amount: true});
  }
  if (meta.priceLabel && hasNonZeroNumber(transaction.price_per_gram_rial)) {
    rows.push({key: 'price', label: meta.priceLabel, value: formatRial(transaction.price_per_gram_rial), amount: true});
  }
  if (hasNonZeroNumber(transaction.amount_rial)) {
    rows.push({key: 'amount', label: meta.amountLabel, value: formatRial(transaction.amount_rial), amount: true, emphasis: true});
  }
  if (hasNonZeroNumber(transaction.tax_amount_rial)) {
    rows.push({key: 'tax', label: 'مالیات ثبت‌شده', value: formatRial(transaction.tax_amount_rial), amount: true});
  }
  if (transaction.bar_id !== null && transaction.bar_id !== undefined && transaction.bar_id !== '') {
    rows.push({key: 'bar', label: 'شناسه شمش', value: toPersianDigits(transaction.bar_id)});
  }

  rows.push({key: 'created', label: 'زمان ثبت', value: formatTransactionDate(transaction.created_at)});
  if (transaction.updated_at && transaction.updated_at !== transaction.created_at) {
    rows.push({key: 'updated', label: 'آخرین تغییر', value: formatTransactionDate(transaction.updated_at)});
  }

  const status = type === 'physical_delivery' && transaction.status === 'completed'
    ? {label: 'کد رهگیری ثبت شده', tone: 'completed', stage: 'tracking', summary: 'کد رهگیری ثبت شده. این وضعیت به معنی تحویل مرسوله به گیرنده نیست.', raw: transaction.status}
    : statusFor(transaction.status);

  return {
    title: meta.title,
    type,
    trackingCode: transaction.tracking_code ? toPersianDigits(transaction.tracking_code) : 'ثبت نشده',
    status,
    rows,
    description: transaction.description ? toPersianDigits(String(transaction.description).trim()) || null : null,
    receipt: receiptFor(transaction.receipt_file),
  };
}

export {STATUS_META, TYPE_META};
